import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {
  ForwardedRef,
  forwardRef,
  Fragment,
  useEffect,
  useState,
} from 'react';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import styles from './IconRating.module.scss';

export interface IconRatingProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  icon: IconProp;
  answer?: string;
  options: number;
  lowerLabel?: string;
  higherLabel?: string;
}

function IconRating(
  {
    icon,
    options,
    lowerLabel,
    higherLabel,
    answer,
    ...inputProps
  }: IconRatingProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  const [checked, setChecked] = useState<string>();

  const optionsArray = Array.from({length: options}, (_, i) => i + 1).reverse();

  useEffect(() => {
    if (answer) setChecked(answer);
  }, [answer]);

  return (
    <fieldset className={styles.rating}>
      {optionsArray.map((option) => (
        <Fragment key={option}>
          <input
            {...inputProps}
            ref={ref}
            type="radio"
            value={option}
            onChange={(event) => {
              setChecked(event.target.value);
              inputProps.onChange?.(event);
            }}
            className={styles.hiddenInput}
            id={`${inputProps.name}_${option}`}
            checked={Number(checked) === option}
          />
          <label
            aria-label={`${option}`}
            htmlFor={`${inputProps.name}_${option}`}
          >
            <FontAwesomeIcon icon={icon} className={styles.icon} />
          </label>
        </Fragment>
      ))}

      <div className={styles.ratingDescription}>
        <span className={styles.ratingLabel}>{lowerLabel}</span>
        <span className={styles.ratingLabel}>{higherLabel}</span>
      </div>
    </fieldset>
  );
}

export default forwardRef(IconRating);
